/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef } from 'react'
import translator from 'src/translate'
import { createCourseAction } from 'src/reducers/course/action'
import {
  AssignmentFieldNames,
  AssignmentSchema,
  AssignmentTypes,
} from 'src/model/assignment'
import { coursePatchAction } from 'src/reducers/course/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { Modal, Typography, withStyles } from '@material-ui/core'
import { CoreButton, CoreIconButton, CoreTextField } from 'src/components/core'
import styles from './styles'
import { mediaImageUploadAction } from 'src/reducers/media-image/action'
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate'
import URL from 'src/api/url/api'
import { track } from '@amplitude/analytics-browser'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
import CountrySelect from 'src/components/language-selection'
import { languages } from 'src/model/languages'
import { shopLanguageGetService } from 'src/api/shop'
import { useHistory } from 'react-router-dom'
import { getCardAction, getCardSuccess } from 'src/reducers/card/action'
import { courseGetSuccess } from 'src/reducers/course/action'
const SETTING_KEY = 'general'
const DEFAULT_COLLECTION_GUID = '00000000-0000-0000-0000-000000000000'
const NamingModal = props => {
  const {
    dispatch,
    handleCloseModal,
    classes,
    isModalOpen,
    selectedAssignmentType,
    id,
    collectionName,
    courseEntity,
    courses,
    coverImageUrlParent,
    setCoverUrl,
  } = props
  const history = useHistory()
  const { execute, update, exists, value } = useCourseSettings(SETTING_KEY)
  const [assignmentTitle, setAssignmentTitle] = React.useState(
    courseEntity ? courseEntity.name : '',
  )
  const [assignmentCoverPageText, setAssignmentCoverPageText] = React.useState(
    courseEntity ? value.coverPageText : null,
  )

  const [coverPage, setCoverPage] = React.useState(
    courseEntity ? value?.coverPage : null,
  )
  const inputRef = useRef(null)

  const languageOptions = languages

  const [languageSelection, setLanguageSelection] = React.useState(
    languageOptions.find(x => x.countryCode === 'en'),
  )

  // New courses start in the workspace language.
  React.useEffect(() => {
    if (courseEntity) return undefined
    let cancelled = false
    shopLanguageGetService()
      .then(response => {
        const language = languageOptions.find(
          x => x.countryCode === response?.data?.languageCode,
        )
        if (!cancelled && language) setLanguageSelection(language)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [courseEntity, languageOptions])
  const handleSaveCourse = () => {
    handleSaveCourseSettings()
    const patchSource = new PatchData(
      null,
      courseEntity[AssignmentFieldNames.ID],
    )
    patchSource.addContent(
      new PatchContent(
        assignmentTitle,
        AssignmentFieldNames.NAME,
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(
      coursePatchAction(patchSource, () => {
        handleCloseModal(true)
      }),
    )
  }

  const handleSaveCourseSettings = () => {
    const variables = {
      ...value,
      coverPage: coverPage,
      coverPageText: assignmentCoverPageText,
    }

    if (!exists) {
      // create a setting entity with execute function
      execute(variables, {})
    } else {
      update(variables, {})
    }
  }
  const handleCreateButton = () => {
    let courseCollectionId = id == 'undefined' ? null : id
    dispatch(
      createCourseAction(
        {
          [AssignmentFieldNames.NAME]: assignmentTitle,
          CourseCollectionId: courseCollectionId,
          CountryCode: languageSelection.countryCode,
        },
        entity => {
          track('Course Created', {
            courseId: entity.id,
          })
          handleCloseModal(true)
          dispatch(getCardSuccess(null))
          dispatch(courseGetSuccess(null))
          history.push('/mini-course/' + entity.id + '/page')
        },
      ),
    )
  }
  const handleTextFieldChange = e => {
    setAssignmentTitle(e.target.value)
  }

  const isTextFieldValid = () => {
    if (courseEntity || assignmentTitle.length >= 1) {
      return true
    }
    return false
  }

  React.useEffect(() => {
    if (isModalOpen) {
      // Add a small delay to ensure the TextField is mounted
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 100)
    }
  }, [isModalOpen])

  const handleKeyPress = e => {
    if (e.key === 'Enter' && isTextFieldValid()) {
      courseEntity ? handleSaveCourse() : handleCreateButton()
    }
  }

  return (
    <Modal
      open={isModalOpen}
      onClose={() => handleCloseModal()}
      className={classes.modal}
      onKeyPress={handleKeyPress}
    >
      <div className={classes.namingModalContent}>
        <div className={classes.headerGroup}>
          <Typography className={classes.headerText}>
            {courseEntity
              ? `Edit Cover`
              : `${translator._('assignment.createOneTime')}`}
          </Typography>
        </div>

        <div className={classes.root__bg}>
          <div className={classes.root__section}>
            <div className={classes.root__content}>
              <CoreTextField
                defaultValue={assignmentTitle}
                label="What’s the name of your course?"
                onChange={handleTextFieldChange}
                id="courseName"
                inputRef={inputRef}
              />

              <span className={classes.description__span}></span>
            </div>
          </div>
          {!courseEntity && (
            <CountrySelect
              languageSelection={languageSelection}
              setLanguageSelection={setLanguageSelection}
              languageOptions={languageOptions}
              label="Choose interface language"
            />
          )}
        </div>
        <div className={classes.buttonGroupNaming}>
          <CoreButton
            variant="text"
            color="dark"
            size="small"
            onClick={handleCloseModal}
          >
            {translator._('assignment.back')}
          </CoreButton>
          <CoreButton
            variant="contained"
            size="small"
            disabled={isTextFieldValid() ? false : true}
            onClick={courseEntity ? handleSaveCourse : handleCreateButton}
          >
            {translator._(
              courseEntity ? 'assignment.save' : 'assignment.create',
            )}
          </CoreButton>
        </div>
      </div>
    </Modal>
  )
}
export default withStyles(styles)(NamingModal)
